import { gql } from 'apollo-boost';

export const getVouchers = gql`
    query GetVouchers(
        $begin: String!,
        $end: String!,
    ){
        vouchers(
            begin: $begin,
            end: $end,
        ){
            _id,
            voucher,
            beginDate,
            endDate,
            room_info{
                name,
                branch_info{
                    name
                }
            },
        }
    }
`;

export const getVouchersByUser = gql`
    query GetVouchersByUser(
        $user: ID!,
        $begin: String!,
        $end: String!,
    ){
        vouchersByUser(
            user: $user,
            begin: $begin,
            end: $end,
        ){
            _id,
            voucher,
            beginDate,
            endDate,
            room_info{
                name,
                branch_info{
                    name
                }
            },
        }
    }
`;

export const getVoucher = gql`
    query GetVoucher(
        $_id: ID!,
    ){
        voucher(
            _id: $_id
        ){
            _id,
            voucher,
            beginDate,
            endDate,
            client_info{
                name,
                document,
                email,
                celphone,
                phone
            }
        }
    }
`;

export const getVoucherByCode = gql`
    query GetVoucherByCode(
        $voucher: String!,
    ){
        voucherByCode(
            voucher: $voucher
        ){
            voucher,
            beginDate,
            endDate,
            room_info{
                _id,
                name,
                link
            },
            client_info{
                _id,
                name
            }
        }
    }
`;


// WEBPACK FOOTER //
// ./src/graphql/query/voucher.js